import { AttachMoney } from '@material-ui/icons';

import List from './List';

export default {
  list: List,
  icon: AttachMoney,
};
